import { Injectable } from '@angular/core';
import { AngularFireStorage, AngularFireUploadTask } from "@angular/fire/storage";
import * as jsPDF from 'jspdf';
import {SENTREX_LOGO} from '../../providers/images';

@Injectable()
export class PdfProvider {

  pdf: any;
  pageHeight: number;
  pageWidth: number;
  pageNumber: number = 0;
  startx: number = 40;
  starty: number = 40;
  x: number = 40;
  y: number = 40;
  supplies: any[] = [];
  doctorsupplies: any[] = [];

  clinic: any;

  task: AngularFireUploadTask;
  filepath: any;

  constructor(private afStorage: AngularFireStorage) {
  }

  public createOrderPDF(clinic, order: any[], note, clinicSupplies: any[], doctorSupplies: any[], injectiondate, order_number)  {
    this.pdf = new jsPDF('p', 'pt', 'letter');
    this.pageHeight = this.pdf.internal.pageSize.height;
    this.pageWidth = this.pdf.internal.pageSize.width;
    this.pageNumber = 0;
    this.pdf.deletePage(1);
    this.supplies = clinicSupplies;
    this.doctorsupplies = doctorSupplies;
    console.log('PDF Supplies: ', this.supplies)
    return new Promise((resolve, reject) => {
      const start = async () => {
        await this.asyncForEach(order, async (doctor_batch, idx) => {
          await this.addRxOrder(doctor_batch, clinic, note, injectiondate, order_number);
          await this.addDefaultSuppliesOrder(clinic, doctor_batch.rx[0].doctor, null, null, order_number)
        });


        await this.addDisclaimer(clinic, order_number);
        console.log('done pdf');
        // this.pdf.save('test.pdf');
        const file = this.pdf.output("blob")
        const filepath = await this.uploadOrdertoFirebase(clinic, file);
        console.log('Finished Everything, here is the file: ', filepath);
        resolve(filepath);
      }
      start();
    });
  }

  public createSupplyPDF(clinic, order: any, note, location, order_number)  {
    this.pdf = new jsPDF('p', 'pt', 'letter');
    this.pageHeight = this.pdf.internal.pageSize.height;
    this.pageWidth = this.pdf.internal.pageSize.width;
    this.pageNumber = 0;
    this.pdf.deletePage(1);
    
    this.supplies = order.supplies;
    return new Promise((resolve, reject) => {
      const start = async () => {
        await this.addSuppliesOrder(clinic, order.doctor, note, location, order_number);
        const file = this.pdf.output("blob")
        const filepath = await this.uploadOrdertoFirebase(clinic, file);
        console.log('Finished Everything, here is the file: ', filepath);
        resolve(filepath);
      }
      start();
    });
  }

  private async addDisclaimer(clinic, order_number) {
    return new Promise(async (resolve, reject) => {
        this.pdf.addPage();
        this.pageNumber += 1;
        this.y = this.starty;

        this.y = 40; 
        this.x = 40;

        // Add Sentrex Logo
        this.pdf.addImage(SENTREX_LOGO, 'png', this.x, this.y, 150, 25, undefined, 'FAST');
        this.y += 50; 

        // Add Clinic Info
        // Clinic Name - Bold
        this.pdf.setFont("helvetica"); 
        this.pdf.setFontType("bold");
        this.pdf.setFontSize(12);
        this.pdf.text(clinic.clinic_name + " - "+ order_number, this.x, this.y); this.y += 40;
        
        this.pdf.setFontType("normal"); 
        this.pdf.setFontSize(10);
        let disclaimer = "";
        disclaimer += "Please deliver this medication to my office on behalf on this patient so I can ensure the drug is properly stored and handled prior to administration. I have informed this patient of their right to choose another pharmacy if they prefer.  To best serve our patients, I will educate them prior to administering the drug on, but not limited to, the following:\n\n";
        disclaimer += " - If he/she has ever received an injection of this medication before, and if so, whether he/she has had an allergic reaction to this product\n";
        disclaimer += " - The medications purpose and recommendation for use\n";
        disclaimer += " - Medication contraindications and possible risks associated with injection administration\n";
        disclaimer += " - Drug-Drug interactions if applicable\n\n";
        disclaimer += "As the prescribing specialist, I am very familiar with this medication, including the consumer information contained in the manufacturer’s product monograph and I am very comfortable counselling on both the injection and drug components. In the interest of our patients and to avoid confusion, please do not counsel for the initial prescription, however please be available to the patient should they call for additional information.";

        let para = this.pdf.splitTextToSize(disclaimer, this.pageWidth - 100);
        let textheight = 10 * para.length * 1.05;
        this.pdf.text(this.x, this.y, para); this.y += 20 + textheight;

        // Footer with Clinic and Page Number
        this.pdf.setFontSize(12);
        this.pdf.line(this.x, this.pageHeight - 40, this.pageWidth - 40, this.pageHeight - 40);
        let nextline = clinic.clinic_name;
        // if(batch.order_batch) { nextline += ' - ' + batch.order_batch; }
        this.pdf.text(nextline, this.x, this.pageHeight - 25);
        this.pdf.text(this.pageNumber.toString(), this.pageWidth - 60, this.pageHeight - 25);
        this.pdf.setFontSize(9);
        this.pdf.text('Pharmacy: No substitutions permitted. Counseling on medication completed during office visit. No additional information required. ', this.x, this.pageHeight - 16);
        this.pdf.setFontSize(12);
        resolve('Footer Complete');
    });
  }

  private async addRxOrder(doctor_batch, clinic, note, injectiondate, order_number)  {
    return new Promise(async (resolve, reject) => {
      // Create New Order Page
      let doctor = doctor_batch.rx[0].doctor;
      doctor.signature = doctor_batch.signature;
      await this.addNewPage(clinic, doctor, injectiondate, null, order_number);
      const start = async () => {
        await this.asyncForEach(doctor_batch.rx, async (rx) => {
          this.pdf.setFontSize(10);
          this.pdf.line(this.x, this.y, this.pageWidth - 40, this.y); this.y += 12;
          let locationname = '';
          if(rx.location.name)  {
            locationname = rx.location.name;
          }
          this.pdf.text(locationname + ' - ' + rx.location.address + ' - ' + rx.location.city, this.x, this.y); 
          this.pdf.text(rx.medication[0].name + ' - ' + rx.eye + ' - ' + rx.quantity + ' - LU Code ' + rx.lucode, this.x + 300, this.y); this.y += 15;
          let patientinfo = rx.patient.first_name + ' ' + rx.patient.last_name + ' - DOB: ' + rx.patient.dob;
          if(rx.patient.gender) {
            patientinfo += ' - ' + rx.patient.gender;
          }
          this.pdf.setFontType("bold");
          this.pdf.setFontSize(12);
          this.pdf.text(patientinfo, this.x, this.y); this.y += 15;
          this.pdf.setFontType("normal");
          this.pdf.setFontSize(10);
          this.pdf.text('Health Card #: ' + rx.patient.healthcard, this.x, this.y);  this.y += 15;
          let patientaddress = rx.patient.address + ' ' + rx.patient.city + ', ' + rx.patient.province + ' ' + rx.patient.postal_code;
          if(rx.patient.phone_number) {
            patientaddress += ' - ' + rx.patient.phone_number;
          } else {
            if (rx.patient.phone_number_primary) {
              patientaddress += ' - ' + rx.patient.phone_number_primary;
            }
          } 
          this.pdf.text(patientaddress, this.x, this.y); this.y += 15;
          if(rx.tobra)  {
            this.pdf.text('Plus: ' + rx.tobra, this.x, this.y); this.y += 15;
          }
          if(rx.note)  {
            let lines = this.pdf.splitTextToSize('RX Note: ' + rx.note, this.pageWidth - 80);
            let textheight = 10 * lines.length * 1.05;
            if (this.y + textheight > this.pageHeight - 140) {
              await this.addNewPage(clinic, doctor, injectiondate, null, order_number);
            }
            this.pdf.setFontSize(10);
            this.pdf.setFontType("normal");
            this.pdf.text(this.x, this.y, lines); this.y += 5;
          } 

          if (this.y + 140 > this.pageHeight) {
            await this.addNewPage(clinic, doctor, injectiondate, null, order_number);
          }
        });
        if(note) {
          await this.addNote(clinic, doctor, note, injectiondate, order_number);
        }
        resolve('Finished order');
      }
      start();
    });
  }

  private async addSuppliesOrder(clinic, doctor, note, location, order_number) {
    return new Promise(async (resolve, reject) => {
      // Create New Supplies Page
      await this.addNewPage(clinic, doctor, null, location, order_number);
      this.pdf.setFontSize(10);
      this.pdf.line(this.x, this.y, this.pageWidth - 40, this.y); this.y += 12;
      this.pdf.setFontType("bold");
      this.pdf.text('Item', this.x, this.y);
      this.pdf.text('Quantity', this.x + 400, this.y); this.y += 7;
      this.pdf.setFontType("normal");
      const start = async () => {
        await this.asyncForEach(this.supplies, async (supply) => {
          this.pdf.setFontSize(10);
          // if(!supply.quantity)  { supply.quantity = 1; }
          // if(!supply.unit)  { supply.unit = "NA"; }
          this.pdf.line(this.x, this.y, this.pageWidth - 40, this.y); this.y += 15;
          this.pdf.text(supply['name'] + ' - ' + supply['din'], this.x, this.y);
          this.pdf.text(supply['quantity'] ? supply['quantity'].toString() : '1', this.x + 400, this.y); this.y += 15;
          this.pdf.text('Unit: ' + supply['unit'] ? supply['unit'] : 'NA', this.x, this.y); this.y += 7;

          if (this.y + 140 > this.pageHeight) {
            await this.addNewPage(clinic, doctor, null, null, order_number);
          }
        });
        if(note) {
          await this.addNote(clinic, doctor, note, null, order_number);
        }
        resolve('Adding supplies supplies');
      }
      start();
    });
  }


  private async addDefaultSuppliesOrder(clinic, doctor, note, location, order_number) {
    return new Promise(async (resolve, reject) => {
      // Create New Supplies Page
      this.doctorsupplies.filter(s => s.doctor.id === doctor.id).map(async (item) => {
        console.log("Default Supply Item: ", item);
        if (item) {
          console.log('Default Doctor Supplies: ', item)
          if (item.supplies.length > 0) {
            await this.addNewPage(clinic, doctor, null, location, order_number);
            console.log('Write doctor default supply page: ', item.supplies)
            this.y += 10;
            this.pdf.setFontSize(14);
            this.pdf.text('Default Doctor Supplies', this.x, this.y); this.y += 15;
            this.pdf.setFontSize(10);
            this.pdf.line(this.x, this.y, this.pageWidth - 40, this.y); this.y += 12;
            this.pdf.setFontType("bold");
            this.pdf.text('Item', this.x, this.y);
            this.pdf.text('Quantity', this.x + 400, this.y); this.y += 7;
            this.pdf.setFontType("normal");
            const start = async () => {
              await this.asyncForEach(item.supplies, async (supply) => {
                this.pdf.setFontSize(10);
                if(!supply.quantity)  { supply.quantity = "Per Rx Unit"; }
                if(!supply.unit)  { supply.unit = "NA"; }
                this.pdf.line(this.x, this.y, this.pageWidth - 40, this.y); this.y += 15;
                this.pdf.text(supply['name'] + ' - ' + supply['din'], this.x, this.y);
                this.pdf.text(supply['quantity'].toString(), this.x + 400, this.y); this.y += 15;
                this.pdf.text('Unit: ' + supply['unit'], this.x, this.y); this.y += 7;
                console.log('Doctor Default Supply: ', supply['name'], this.y, this.pageHeight)
                if (this.y + 140 > this.pageHeight) {
                  console.log('Adding a new page', supply['name'], this.y, this.pageHeight);
                  await this.addNewPage(clinic, doctor, null, null, order_number);
                }
              });
              resolve('Adding doctor default supplies');
            }
            start();
          }
          else {
            resolve('No default supplies for this doctor');
          }
        } 
        else {
          resolve('No default supplies for this doctor');
        }
      })
    });
  }

  private async addNewPage(clinic, doctor, injectiondate, location, order_number) {
    return new Promise(async (resolve, reject) => {
      this.pdf.addPage();
      this.pageNumber += 1;
      this.y = this.starty;
      await this.addHeader(clinic, doctor, injectiondate, location, order_number);
      await this.addFooter(clinic, doctor);
      resolve('New Page Added');
    });
  }

  private async addHeader(clinic, doctor, injectiondate, location, order_number) {
    return new Promise<void>((resolve, reject) => {
      this.y = 40; 
      this.x = 40;

      // Add Sentrex Logo
      this.pdf.addImage(SENTREX_LOGO, 'png', this.x, this.y, 150, 25, undefined, 'FAST');
      this.y += 50; 

      // Add Clinic Info
      // Clinic Name - Bold
      this.pdf.setFont("helvetica"); 
      this.pdf.setFontType("bold");
      this.pdf.setFontSize(12);
      this.pdf.text(clinic.clinic_name + " - "+ order_number, this.x, this.y); this.y += 15;
      this.pdf.setFontType("normal"); 
      if(location)  {
        this.pdf.text(location.name + ' - ' + location.address + ' - ' + location.city, this.x, this.y);  this.y += 15;
      }
      // Clinic Address & Phone Number - Normal
      // this.pdf.text(clinic.address.address, this.x, this.y); this.y += 15;
      // this.pdf.text(clinic.address.city + ', ' + clinic.address.province + ' ' + clinic.address.postal_code, this.x, this.y); this.y += 15;
      // if(clinic.phone_number)  {
      //   this.pdf.text('Tel: ' + clinic.phone_number, this.x, this.y); this.y += 15;
      // }
      // Add Doctor 
      this.pdf.setFontType("bold");
      this.pdf.text('Dr. ' + doctor.first_name + ' ' + doctor.last_name, this.x, this.y);  this.y += 15;
      this.pdf.setFontType("normal");
      if(injectiondate) {
        this.pdf.text('Injection Date: ' + injectiondate, this.x, this.y); this.y += 30;
      }
      resolve();
    });
  }

  private addFooter(clinic, doctor)  {
    return new Promise((resolve, reject) => {
      // Append Dr. Signature Per Page
      this.pdf.addImage(doctor.signature, 'png', this.x, this.pageHeight - 110, 120, 37.5, undefined, 'FAST');
      this.pdf.line(this.x, this.pageHeight - 70, this.x + 150, this.pageHeight - 70);
      this.pdf.setFontSize(10);
      this.pdf.text('Dr. ' + doctor.first_name + ' ' + doctor.last_name, this.x, this.pageHeight - 60);
      this.pdf.text((new Date().toLocaleString()), this.x, this.pageHeight - 50);

      // Footer with Clinic and Page Number
      this.pdf.setFontSize(12);
      this.pdf.line(this.x, this.pageHeight - 40, this.pageWidth - 40, this.pageHeight - 40);
      let nextline = clinic.clinic_name;
      // if(batch.order_batch) { nextline += ' - ' + batch.order_batch; }
      this.pdf.text(nextline, this.x, this.pageHeight - 25);
      this.pdf.text(this.pageNumber.toString(), this.pageWidth - 60, this.pageHeight - 25);
      this.pdf.setFontSize(9);
      this.pdf.text('Pharmacy: No substitutions permitted. Counseling on medication completed during office visit. No additional information required. ', this.x, this.pageHeight - 16);
      this.pdf.setFontSize(12);
      resolve('Footer Complete');
    });
  }

  private async addNote(clinic, doctor, note, injectiondate, order_number)  {
    return new Promise(async (resolve, reject) => {
      if(note)  {
        this.y += 20;
        let lines = this.pdf.splitTextToSize('Order Note: ' + note, this.pageWidth - 80);
        let textheight = 10 * lines.length * 1.05;
        if (this.y + textheight > this.pageHeight - 140) {
          await this.addNewPage(clinic, doctor, injectiondate, null, order_number);
        }
        this.pdf.setFontSize(10);
        this.pdf.setFontType("normal");
        this.pdf.text(this.x, this.y, lines);
      } 
      resolve('Added Note');
    });
  }

  private async uploadOrdertoFirebase(clinic, file: any) {
    return new Promise((resolve, reject) => {
      let filePath: any = null;
      filePath = `orders/${clinic.clinic_name}_${new Date().getTime()}.pdf`;
  
      console.log("File Path: ", filePath);
      this.task = this.afStorage.ref(filePath).put(file);
    
      this.task.then((t) => {
        t.ref.getDownloadURL().then((u) => {
          console.log("File Upload Complete: ", file); 
          resolve(u);
        })
      }).catch(error => {
        console.log('Upload Error');
        reject(null);
      });
    });
  }

  async asyncForEach(array, callback) {
    for (let index = 0; index < array.length; index++) {
      await callback(array[index], index, array)
    }
  }
}



// WEBPACK FOOTER //
// ./src/providers/pdf/pdf.ts